<template>
    <v-container mb-12>
        <v-row justify="center">
            <!-- Image -->
            <v-col
                cols="12"
                sm="6"
            >
                <div
                    class="d-flex fill-height align-center justify-center"
                >
                    <v-img
                        max-width="80%"
                        :src="require('../assets/manage_chats.svg')"
                    />
                </div>
            </v-col>
            <!-- Form -->
            <v-col
                cols="12"
                sm="6"
            >
                <v-form
                    ref="form"
                    @submit.prevent="onSubmit"
                >
                    <v-row justify="center">
                        <v-col
                            cols="12"
                            lg="8"
                            class="text-center"
                        >
                            <h1 class="display-2 mb-2">
                                Contact Us
                            </h1>
                            <p>
                                Have a question? We'd love to hear from you.<br>
                                Send us a message and we'll get back to you as soon as possible.
                            </p>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <v-text-field
                                label="Name"
                                v-model="name"
                                :rules="[
                                    rules.required
                                ]"
                                validate-on-blur
                                color="secondary"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <v-text-field
                                label="Email"
                                type="email"
                                v-model="email"
                                :rules="[
                                    rules.required,
                                    rules.email
                                ]"
                                validate-on-blur
                                color="secondary"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <v-textarea
                                label="Message"
                                color="secondary"
                                v-model="message"
                                :rules="[
                                    rules.required
                                ]"
                                validate-on-blur
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <vue-recaptcha
                                ref="invisibleRecaptcha"
                                :sitekey="sitekey"
                                badge
                                size="invisible"
                                @verify="onVerify"
                                :load-recaptcha-script="true"
                            />
                            <v-btn
                                type="submit"
                                :loading="isSubmitting"
                                :disabled="isSubmitting"
                                color="primary"
                                block
                                large
                            >
                                Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import MessageBus from '../utils/buses/MessageBus'
import VueRecaptcha from 'vue-recaptcha'
import { defaultError, default422Error } from '../utils/constants/errors'
import { requiredValidation, emailValidation } from '../utils/validations'

export default {
    components: {
        VueRecaptcha
    },
    data () {
        return {
            sitekey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
            name: null,
            email: null,
            message: null,
            rules: {
                required: requiredValidation,
                email: emailValidation
            },
            isSubmitting: false
        }
    },
    methods: {
        onVerify (recaptchaResponse) {
            axios.post('/contact-us', {
                name: this.name,
                email: this.email,
                message: this.message,
                recaptchaResponse
            })
                .then(res => {
                    MessageBus.sendMessage('Thank you for your message. We will get back to you as soon as possible.', 'success')
                })
                .catch(err => {
                    console.error('Error sending message', err)
                    MessageBus.sendMessage(defaultError, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        onSubmit () {
            this.isSubmitting = true
            if (!this.$refs.form.validate()) {
                MessageBus.sendMessage(default422Error, 'error')
                this.isSubmitting = false
                return
            }
            this.$refs.invisibleRecaptcha.reset()
            this.$refs.invisibleRecaptcha.execute()
        }
    }
}
</script>
